import dayjs from 'dayjs';

import { LOCALIZED_DATE } from 'technical/string/formatter';
import 'technical/time-utils/dayjs.timezone';

export const formatDateWithMiddleDot = (date: string | null | undefined) => {
  if (!date) {
    return '-';
  }
  return dayjs(date).tz().format('DD/MM/YYYY \u2022 HH:mm');
};

export const formatDate = (dateString: string | null) => {
  if (!dateString) {
    return '-';
  }
  return dayjs(dateString).tz().format('DD/MM/YYYY');
};

export const formatLocalizedDate = (dateString: string | null) => {
  if (!dateString) {
    return '-';
  }

  const date = dayjs(dateString).tz();
  if (!date.isValid()) {
    return '-';
  }

  return date.format(LOCALIZED_DATE);
};
